module.exports = __webpack_public_path__ + "static/media/vector2_1.76c25048.png";